import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ImprovementPlanListDeleteResultApiModel, ImprovementPlanResolutionApiModel } from '@app/api/api-models';
import { CrudService } from '@app/api/api-services/crud.service';

@Injectable()
export class ImprovementPlanResolutionsService extends CrudService<ImprovementPlanResolutionApiModel, number> {
  public readonly apiUrl = 'improvement-plan-resolutions';

  public deleteWithGuard(id: number): Observable<ImprovementPlanListDeleteResultApiModel> {
    return this.http.delete<ImprovementPlanListDeleteResultApiModel>(`${this.apiUrl}/delete/${id}`);
  }
}
